import { IconProps } from "./";
import Icon from "./assets/id_card_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24IdCard(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
